"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedTick = void 0;
var React = require("react");
var browser = require("../../_Core/Browser");
var AnimatedTick_styles_1 = require("./AnimatedTick.styles");
var AnimatedTick = function (_a) {
    var Size = _a.Size;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: Size, height: Size, viewBox: "0 0 37 37" }, 
    // We are using the browser functions below to detect IE11 that does not suppport fully SVG Animations.
    // This is the last resort to detect IE11 as we are not aware at this stage how to detect the missing functionality.
    browser.HasDocumentMode() && browser.HasMSInputMethodContext() ?
        React.createElement(AnimatedTick_styles_1.PolyLineLegacy, { className: "tickFill", points: "11.6,20 15.9,24.2 26.4,13.8 " })
        :
            React.createElement(AnimatedTick_styles_1.PolyLine, { className: "tickFill", points: "11.6,20 15.9,24.2 26.4,13.8 " })));
};
exports.AnimatedTick = AnimatedTick;
